import {createContext} from "react";

export const DashboardHeaderContext = createContext(null)